import { Grid, withStyles } from '@material-ui/core';
import { PickupStatus, PickupDetails, BillingDetails, PickupToggleInfo } from '../components';
import RequestorDetails from './ReservationRequestorDetails';
import PickupInfoGridTab from './PickupInfoGrids/PickupInfoGridTab';
import {
  shouldShowRequestorInPickupInfoPopup,
  getFormattedPickupToggleInfo
} from '../utils';
import styles from './styles';
import GroupPickupNumbersSection from './GroupPickupNumbersSection';
import { withAppConfig } from '@appConfigContext';

const RightInfoPanel = ({ pickInfoStateData, configJSON }) => {
  const { pickupInfo, terminalCode, isGroupPickupDialog, groupMemberPickups } = pickInfoStateData;
  const pickupToggleInfoList = getFormattedPickupToggleInfo(pickupInfo);
  const pickupNumbersInGroup = (groupMemberPickups || [])
    .map((p) => p.pickupNumber)
    .filter(Boolean);
  return (
    <Grid container spacing={24}>
      {pickupToggleInfoList.length ? (
        <Grid item xs={12}>
          <PickupToggleInfo pickupInfoList={pickupToggleInfoList} />
        </Grid>
      ) : null}
      {isGroupPickupDialog ? (
        <GroupPickupNumbersSection pickupNumbers={pickupNumbersInGroup} />
      ) : null}
      <Grid item xs={12}>
        <PickupStatus
          data={pickupInfo}
          statusTitle={isGroupPickupDialog ? 'Group Status' : undefined}
          groupMemberPickups={isGroupPickupDialog ? groupMemberPickups : undefined}
        />
      </Grid>
      <Grid item xs={12}>
        <PickupDetails
          pickupInfo={pickupInfo}
          terminalCode={terminalCode}
          groupMemberPickups={isGroupPickupDialog ? groupMemberPickups : undefined}
        />
      </Grid>
      <Grid item xs={12}>
        <PickupInfoGridTab pickInfoStateData={pickInfoStateData} />
      </Grid>
      {!isGroupPickupDialog ? (
        <Grid item xs={12}>
          <BillingDetails data={pickupInfo} />
        </Grid>
      ) : null}
      {shouldShowRequestorInPickupInfoPopup({
        enableRequestorDetailsForPickups: configJSON?.enableRequestorDetailsForPickups,
        isGroupPickupDialog
      }) ? (
        <Grid item xs={12}>
          <RequestorDetails data={pickupInfo} />
        </Grid>
      ) : null}
    </Grid>
  );
};

export default withAppConfig(withStyles(styles)(RightInfoPanel));
